import React from 'react';
import './vip.css'

import {
    Snackbar,
    withStyles,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';

const vipLevelBg = [
    require('../../images/vip/vip_bg_0.png'),
    require('../../images/vip/vip_bg_1.png'),
    require('../../images/vip/vip_bg_2.png'),
    require('../../images/vip/vip_bg_3.png'),
    require('../../images/vip/vip_bg_4.png'),
    require('../../images/vip/vip_bg_5.png'),
]
const vipLevelTitle = [
    require('../../images/vip/vip_title_0.png'),
    require('../../images/vip/vip_title_1.png'),
    require('../../images/vip/vip_title_2.png'),
    require('../../images/vip/vip_title_3.png'),
    require('../../images/vip/vip_title_4.png'),
    require('../../images/vip/vip_title_5.png'),
]
const vipLevelImg = [
    require('../../images/vip/vip_level_1.png'),
    require('../../images/vip/vip_level_2.png'),
    require('../../images/vip/vip_level_3.png'),
    require('../../images/vip/vip_level_4.png'),
    require('../../images/vip/vip_level_5.png')
]
// const redBagBg = require('../../images/vip/redBagBg.png')

const textColor = [
    '#E3E8AB',
    '#AB6D50',
    '#77779B',
    '#AF6E1A',
    '#9053B4',
    '#FFFFFF'
]

const progessColor = [
    '#7A7D57',
    '#AB6D50',
    '#A0A0AF',
    '#AF6E1A',
    '#958EC5',
    '#FFFFFF'
]


const VIPDESC = [
    '恭喜您，成为我们的新秀之星',
    '您已经打败全国40%的用户',
    '您已经打败全国60%的用户',
    '您已经打败全国78%的用户',
    '您已经打败全国88%的用户',
    '您已打败了全国98%的用户'
]

const LEVEL = ['新秀', '黄铜', '白银', '黄金', '铂金', '钻石']



class VipLevel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            level: 0,
            is_send: 1,
            nextexp: 0,
            totalexp: 1,
            ret: 0,
            score: 0,
            snackopened: false,
            message: ''
        }

    }

    componentDidMount() {
        let { os } = this.props.match.params;
        if (os && os != '') {
            AppData.os = os
        }
        else {
            AppData.os = 'h5'
        }
        this.getVipData();
        AppUtils.YMPush('MAIN', 'VipLevelPage');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }


    getVipData = async () => {
        let { customerId, token, uid } = this.props.match.params;
        
        let result = await Apis.getVipData(customerId ? customerId : uid, token, 4);
        console.log("getVipData", result);
        if (result.code == 200) {
            let data = result.data;
            this.setState({
                level: data.level,
                is_send: data.is_send,
                nextexp: data.nextexp,
                totalexp: data.totalexp,
                ret: data.ret,
                score: data.score,
            });
        } else {
            this.setState({ message: result.msg, snackopened: true })
        }
    }

    onClickReward = async () => {
        const { is_send } = this.state;
        if (is_send == 0) {
            return
        }
        let { channel, uid, token } = this.props.match.params;
        let result = await Apis.vipReward(uid, token, channel);
        if (result.code == 200) {
            if (result.data.ret == 1) {
                this.setState({ is_send: 0 });
            }
        }
        this.setState({ message: result.msg, snackopened: true })
    }


    textDec = () => {
        return (
            <div style={{ marginLeft: 15 }}>
                <div className='textTitle'>成长值如何获取？</div>
                <div className='itemtext'>1：每日登录，获得2成长值；</div>
                <div className='itemtext'>2：每日直播聊天室互动，获得2成长值；</div>
                <div className='itemtext'>3：每日添加一个主播FID，获得2成长值；</div>
                <div className='itemtext'>4：每日观看直播10分钟或10分钟以上，获得10成长值；</div>
                <div className='itemtext'>5：每日邀请一名新的用户，可获得50成长值；</div>
            </div>
        )
    }

    // vip等级
    render() {
        const { classes } = this.props;
        const { level, snackopened, message, totalexp, score, is_send, nextexp } = this.state
        let tmpLevel = level % 6;
        const LEVEL_EXP_TIPS = '还差' + nextexp + '成长值可升级';

        let progress = (((totalexp - nextexp) / totalexp) * 100) + '%';

        let { nav } = this.props.match.params;
        if (nav && nav == 1) {
            nav = 1
        } else {
            nav = 0
        }

        return (
            <MBack title='VIP会员' backgroundColor="#FFFFFF"  hideNav={nav} >
                <div>
                    <div className={classes.vipBgBox}>
                        <img className='vipBg' src={vipLevelBg[tmpLevel]}></img>
                        <div className='vipView'>
                            <div style={{ width: this.state.level > 0 ? '60%' : '100%' }}>
                                <div className='vipTitleRow'>
                                    <img src={vipLevelTitle[tmpLevel]} />
                                    <span style={{ color: textColor[tmpLevel] }}>会员</span>
                                </div>
                                <div className='vipSubTitle' style={{ color: textColor[tmpLevel] }}>{VIPDESC[tmpLevel]}</div>
                                {
                                    tmpLevel != 5 && <div className='slider'>
                                        <div className='sliderBottm' style={{ backgroundColor: progessColor[tmpLevel] }}></div>
                                        <div className='sliderTop' style={{ width: progress }}></div>
                                    </div>
                                }
                                {
                                    tmpLevel != 5 && <div className='sliderDec' style={{ color: textColor[tmpLevel] }}>
                                        <span>{LEVEL[tmpLevel]}</span>
                                        <span>{LEVEL_EXP_TIPS}</span>
                                        <span>{LEVEL[tmpLevel + 1]}</span>
                                    </div>
                                }
                            </div>

                            <div className='vipImgRight'>
                                {tmpLevel > 0 && <img src={vipLevelImg[tmpLevel - 1]}></img>}
                            </div>
                        </div>
                    </div>
                    {
                        tmpLevel > 1 && <div style={{ marginLeft: 12, marginRight: 12, marginTop: 16 }}>
                            <div style={{ fontSize: 14, color: '#0D0D0D', fontWeight: 'bold', marginBottom: 12 }}>
                                <span>专享红包</span>
                            </div>
                            <div className='redbagView'>
                                <div className='conent'>
                                    <div className='num'>{score}</div>
                                    <div className='dec'>
                                        <div className='dectop'>积分红包</div>
                                        <div className='decbo'>积分可兑换积分商城的商品</div>
                                    </div>
                                </div>
                                <div className='btn' onClick={() => this.onClickReward()}>{is_send == 1 ? '领取' : '已领取'}</div>
                            </div>
                        </div>
                    }
                    {this.textDec()}
                </div>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    vipBgBox: {
        width: '100vm',
        marginLeft: 15,
        marginRight: 15,
        marginTop: 10,
        position: 'relative'
    }
}))(VipLevel));